document.addEventListener("DOMContentLoaded", () => {

  const iconPlay = `<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
    <polygon points="2,1 11,6 2,11"/>
  </svg>`;

  const iconPause = `<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
    <rect x="1" y="1" width="4" height="10"/>
    <rect x="7" y="1" width="4" height="10"/>
  </svg>`;

  const iconMute = `<svg width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
    <path d="M1 4.5h2.5L7 1.5v10L3.5 8.5H1zM9.5 4.5l2.5 2.5"/>
    <line x1="9.5" y1="4.5" x2="12" y2="7" stroke="currentColor" stroke-width="1.5"/>
    <line x1="12" y1="4.5" x2="9.5" y2="7" stroke="currentColor" stroke-width="1.5"/>
  </svg>`;

  const iconUnmute = `<svg width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
    <path d="M1 4.5h2.5L7 1.5v10L3.5 8.5H1z"/>
    <path d="M9 3.5c1.5 0.8 2.5 2.3 2.5 4s-1 3.2-2.5 4"
      fill="none" stroke="currentColor" stroke-width="1.4"/>
  </svg>`;

  const cards = document.querySelectorAll(".ninja-video-card");

  // 🔥 GLOBAL TRACKERS (MAIN FIX)
  let activeVideo = null;
  let activeMuteBtn = null;

  cards.forEach((card) => {

    const video = card.querySelector("video");
    const playBtn = card.querySelector(".ninja-video-play");

    if (!video || !playBtn) return;

    // create mute button if missing
    let muteBtn = card.querySelector(".ninja-video-mute");

    if (!muteBtn) {
      muteBtn = document.createElement("div");
      muteBtn.classList.add("ninja-video-mute");
      card.appendChild(muteBtn);
    }

    // default state
    video.muted = true;
    playBtn.innerHTML = iconPlay;
    muteBtn.innerHTML = iconMute;

    // =========================
    // PLAY / PAUSE
    // =========================
    video.addEventListener("play", () => {
      playBtn.innerHTML = iconPause;
    });

    video.addEventListener("pause", () => {
      playBtn.innerHTML = iconPlay;
    });
    // =========================
    // MUTE / UNMUTE (GLOBAL ONE SOUND RULE)
    // =========================
    muteBtn.addEventListener("click", (e) => {
      e.stopPropagation();

      // 🔥 If another video is already unmuted → mute it first
      if (activeVideo && activeVideo !== video) {
        activeVideo.muted = true;

        if (activeMuteBtn) {
          activeMuteBtn.innerHTML = iconMute;
        }
      }

      // toggle current
      video.muted = !video.muted;

      if (!video.muted) {
        muteBtn.innerHTML = iconUnmute;
        activeVideo = video;
        activeMuteBtn = muteBtn;
      } else {
        muteBtn.innerHTML = iconMute;
        activeVideo = null;
        activeMuteBtn = null;
      }
    });

    // =========================
    // CARD CLICK PLAY/PAUSE
    // =========================
    card.addEventListener("click", (e) => {
      if (e.target === playBtn || e.target === muteBtn) return;

      if (video.paused) {
        video.play();
        playBtn.innerHTML = iconPause;
      } else {
        video.pause();
        playBtn.innerHTML = iconPlay;
      }
    });

  });

});